"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isCtrlOrMetaPressed_1 = require("../eventApi/isCtrlOrMetaPressed");
/**
 * Edit Component helps handle Content edit features
 */
var EditPlugin = /** @class */ (function () {
    function EditPlugin() {
        this.featureMap = {};
        this.autoCompleteSnapshot = null;
        this.autoCompleteChangeSource = null;
    }
    EditPlugin.prototype.getName = function () {
        return 'Edit';
    };
    EditPlugin.prototype.initialize = function (editor) {
        var _this = this;
        this.editor = editor;
        this.addFeature({
            keys: [8 /* BACKSPACE */],
            shouldHandleEvent: function () { return _this.autoCompleteSnapshot !== null; },
            handleEvent: function (event, editor) {
                event.rawEvent.preventDefault();
                editor.setContent(_this.autoCompleteSnapshot, false /*triggerContentChangedEvent*/);
            },
        });
    };
    EditPlugin.prototype.dispose = function () {
        this.editor = null;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    EditPlugin.prototype.onPluginEvent = function (event) {
        var contentChanged = false;
        var currentFeature = this.findFeature(event);
        switch (event.eventType) {
            case 6 /* ContentChanged */:
                contentChanged = this.autoCompleteChangeSource != event.source;
                break;
            case 4 /* MouseDown */:
            case 0 /* KeyDown */:
                contentChanged = true;
                break;
        }
        if (currentFeature) {
            currentFeature.handleEvent(event, this.editor);
        }
        if (contentChanged) {
            this.autoCompleteSnapshot = null;
            this.autoCompleteChangeSource = null;
        }
    };
    /**
     * Add a Content Edit feature
     * @param feature The feature to add
     */
    EditPlugin.prototype.addFeature = function (feature) {
        var _this = this;
        feature.keys.forEach(function (key) {
            var array = _this.featureMap[key] || [];
            array.push(feature);
            _this.featureMap[key] = array;
        });
    };
    /**
     * Perform an auto complete action in the callback, save a snapsnot of content before the action,
     * and trigger ContentChangedEvent with the change source if specified
     * @param callback The auto complete callback, return value will be used as data field of ContentChangedEvent
     * @param changeSource Chagne source of ContentChangedEvent. If not passed, no ContentChangedEvent will be  triggered
     */
    EditPlugin.prototype.performAutoComplete = function (callback, changeSource) {
        var _this = this;
        this.editor.addUndoSnapshot(function (start, end, snapshot) {
            var data = callback();
            _this.autoCompleteSnapshot = snapshot;
            _this.autoCompleteChangeSource = changeSource;
            return data;
        }, changeSource);
    };
    EditPlugin.prototype.findFeature = function (event) {
        var _this = this;
        var hasFunctionKey = false;
        var features;
        var ctrlOrMeta = false;
        if (event.eventType == 0 /* KeyDown */) {
            var rawEvent = event.rawEvent;
            ctrlOrMeta = isCtrlOrMetaPressed_1.default(rawEvent);
            hasFunctionKey = ctrlOrMeta || rawEvent.altKey;
            features = this.featureMap[rawEvent.which];
        }
        else if (event.eventType == 6 /* ContentChanged */) {
            features = this.featureMap[2048 /* CONTENTCHANGED */];
        }
        return (features &&
            features.filter(function (feature) {
                return (feature.allowFunctionKeys || !hasFunctionKey) &&
                    feature.shouldHandleEvent(event, _this.editor, ctrlOrMeta);
            })[0]);
    };
    return EditPlugin;
}());
exports.default = EditPlugin;
//# sourceMappingURL=EditPlugin.js.map